import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ReactNode, useState } from 'react';
import { Link } from 'react-router';
import { typedMemo } from '../../../utils/typed-memo';
import { NavigationProvider } from './NavigationContext';
import { useNavigation } from './useNavigation';

interface NavigationMenuItemProps {
  target?: string;
  text: string;
  icon: ReactNode;
  onClick?: () => void;
  children?: ReactNode;
}

export const NavigationMenuItem = typedMemo(
  ({
    target,
    text,
    icon,
    onClick,
    children,
  }: Readonly<NavigationMenuItemProps>) => {
    const { onItemClick: contextOnClick, currentDepth } = useNavigation();
    const handleClick = onClick || contextOnClick;
    const [open, setOpen] = useState(true);
    const calculatedSx = { pl: currentDepth * 2 };

    const toggleOpen = () => setOpen(!open);

    const itemOnClick = target ? handleClick : toggleOpen;

    const renderedChildren = children ? (
      <NavigationProvider
        onItemClick={contextOnClick}
        currentDepth={currentDepth + 2}
      >
        {children}
      </NavigationProvider>
    ) : null;

    return (
      <>
        <ListItem disablePadding sx={calculatedSx}>
          <ListItemButton
            component={target ? Link : 'div'}
            to={target}
            onClick={itemOnClick}
          >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={text} />
            {children && (open ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        </ListItem>
        {children && (
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {renderedChildren}
            </List>
          </Collapse>
        )}
      </>
    );
  },
);
